import { ModuleBase } from "@/modules/base";
import { Component, Mixins } from 'vue-property-decorator';
import ContextMenu from './ContextMenu/index.vue'

@Component
export class ExternalServicesModule extends Mixins(ModuleBase) {
  show = false

  get outlet() {
    return {
      contextMenu: ContextMenu,
    }
  }
}
